<template>
  <!-- <Navbar/> -->
  <SideBar/>
  <div class="card main-content">
    <!-- <div class="card"> -->
        <div class="progress-spinner" v-if="spinnerLoadingStatus">
            <ProgressSpinner></ProgressSpinner>
        </div>
        <div class="surface-ground ">
            <Card>
              <template #content>
                <DataTable :value="invoices" :size="small" :loading="loadingStatus" v-model:filters="filters" tableStyle="min-width: 50rem" stripedRows paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" v-model:expandedRows="expandedRows" dataKey="id" @rowExpand="onRowExpand" @rowCollapse="onRowCollapse" scrollable scrollHeight="70vh">

                  <template #header >
                      <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                          <span class="text-xl text-900 font-bold">Invoices</span>
                          <div class="flex justify-content-end">
                              <InputText v-model="filters['global'].value" placeholder="Keyword Search"  />
                              <router-link to="/new-invoice" rel="noopener">
                                  <Button class="p-button-sm ml-2" size="small" label="New Invoice" icon="pi pi-plus" raised />
                              </router-link>
                          </div>
                      </div>
                  </template>

                  <Column expander style="width: 5rem"/>
                  <Column field="invoiceNo" header="Invoice No."/>
                  <Column field="from" header="OEM"/>
                  <Column field="invoiceDate" header="Date"/>
                  <Column field="basicAmt" header="Basic">
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.basicAmt)}}
                    </template>
                  </Column>
                  <Column field="igst" header="IGST">
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.igst)}}
                    </template>
                  </Column>
                  <Column field="discAmt" header="Disc. Amt">
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.discAmt)}}
                    </template>
                  </Column>
                  <Column field="totalValue" header="Total">
                    <template #body="slotProps">
                        {{formatCurrency(slotProps.data.totalValue)}}
                    </template>
                  </Column> 
                  <Column field="remarks" header="Remarks">
                    <template #body="slotProps">
                      <Button icon="pi pi-angle-down" size="small" severity="info" raised @click="toggleRemarks($event, slotProps.data)"></Button>
                    </template>
                  </Column>            

                  <template #expansion="slotProps">
                    <DataTable :value="slotProps.data.invoiceItems" :size="small">
                      <Column field="name" header="Item"/>
                      <Column field="hsn" header="HSN"/>
                      <Column field="quantity" header="Quantity"/>
                      <Column field="batchNo" header="Batch"/>
                      <Column header="Mfg/Expiry">
                        <template #body="slotProps">
                          <label class="text-green-500">{{slotProps.data.mfgDate }}</label>/<label class="text-red-500">{{ slotProps.data.expDate}}</label> 
                        </template>
                      </Column>
                      <Column header="Part/Model">
                        <template #body="slotProps">
                          {{slotProps.data.partNo}}/{{slotProps.data.modelNo}}
                        </template>
                      </Column>
                      <Column field="rate" header="Rate"/>
                      <Column field="oemRate" header="PO Rate"/>
                      <Column field="gstRate" header="GST(%)"/>
                      <Column field="gst" header="GST"/>
                      <Column field="discAmt" header="Discount"/>
                      <Column field="subTotal" header="Total Incl-GST"/>
                      <Column header="Parts"> 
                          <template #body="slotProps">
                            <Button v-if="slotProps.data.parts.length > 0" label="Parts" icon="pi pi-window-maximize" raised @click="showParts(slotProps.data)"></Button>
                            <label v-else>NA</label>
                          </template>
                      </Column>
                    </DataTable>
                  </template>

                </DataTable>
              </template>
            </Card>
        </div>
    <!-- </div> -->

    <OverlayPanel ref="remarks" style="width: 20rem;">
      <div class="flex justify-content-start flex-wrap">
          <div class="flex align-items-center justify-content-center">
            <label class="font-semibold">Remarks: </label>
          </div>
        </div>
        <div class="flex justify-content-start flex-wrap">
          <div class="flex align-items-center justify-content-center">
            {{ remarks }}
          </div>
      </div>
    </OverlayPanel>
  </div>

  <Dialog :header="partsDialogHeader" v-model:visible="showPartsDialog" :modal="true" :style="{ width: '50vw' }">
    
    <DataTable :value="parts" showGridlines tableStyle="min-width: 50rem">
        <Column field="name" header="Part"></Column>
        <Column field="quantity" header="Qty">
          <template #body="slotProps">
            {{formatNumber(slotProps.data.quantity)}}
          </template>
        </Column>
        <Column field="modelNo" header="Model No"></Column>
        <Column field="partNo" header="Part/Serial No"></Column>
        <Column field="rate" header="Rate">
          <template #body="slotProps">
            {{formatCurrency(slotProps.data.rate)}}
          </template>
        </Column>
        <Column field="gstRate" header="GST(%)">
          <template #body="slotProps">
            {{formatNumber(slotProps.data.gstRate)}}
          </template>
        </Column>
        <Column field="gstAmt" header="GST">
          <template #body="slotProps">
            {{formatCurrency(slotProps.data.gstAmt)}}
          </template>
        </Column>
        <Column field="discRate" header="Disc(%)">
          <template #body="slotProps">
            {{formatNumber(slotProps.data.discRate)}}
          </template>
        </Column>
        <Column field="discAmt" header="Disc">
          <template #body="slotProps">
            {{formatCurrency(slotProps.data.discAmt)}}
          </template>
        </Column>
        <Column field="subTotal" header="Subtotal">
          <template #body="slotProps">
            {{formatCurrency(slotProps.data.subTotal)}}
          </template>
        </Column>        
    </DataTable>

    <template #footer>
      <Button label="Close" text severity="secondary" @click="showPartsDialog = false" />
    </template>
  </Dialog>

</template>

<script>
import Card from 'primevue/card'
import { getInvoices } from '@/services/apiService'
// import Card from 'primevue/card'
// import Navbar from '../header/headerNavbar.vue'
import ProgressSpinner from 'primevue/progressspinner'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import { FilterMatchMode } from 'primevue/api'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import SideBar from '../sidebar/sideBarTwo.vue'
import Dialog from 'primevue/dialog'
import OverlayPanel from 'primevue/overlaypanel'

export default {
  
  components:{
    // Navbar,
    SideBar,
    Card,
    ProgressSpinner,
    DataTable,
    Column,
    Button,
    InputText,
    Dialog,
    OverlayPanel,
  },

    data(){
      return{
        spinnerLoadingStatus:false,
        loadingStatus:false,
        expandedRows:[],
        invoices:[],
        filters: {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            invoiceNo: { value: null, matchMode: FilterMatchMode.IN },
            from: { value: null, matchMode: FilterMatchMode.IN },
        },
        showPartsDialog: false,
        parts: [],
        partsDialogHeader: 'Parts Details',
        remarks:null,
      }
    },

    methods:{
      getInvoiceList(){
        this.spinnerLoadingStatus = true;
        getInvoices().then((res)=>{          
          this.invoices = res.data;
          this.spinnerLoadingStatus = false;
        }).catch((error)=>{
          this.showErrorToast(error.response.data);
          this.spinnerLoadingStatus = false;
        })
      },
      formatCurrency(value) {
          return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
      },
      formatNumber(value){
        return value.toLocaleString('en-IN');
      },
      showParts(data){
        this.parts = [];
        this.partsDialogHeader = 'Parts details for '+data.name;
        this.parts = data.parts;
        this.showPartsDialog = true;

      },
      toggleRemarks(event, data){
        this.remarks = data.remarks;
        this.$refs.remarks.toggle(event);
      },
      showErrorToast(error){
          this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 3000 });
      },
      showSuccessToast(data){
          this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
      },
    },

    mounted(){
      this.getInvoiceList();
    }
}
</script>

<style scoped>

.progress-spinner {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */
.progress-spinner:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.53);
}

</style>